import React from 'react';
import PropTypes from 'prop-types';

const ComponentClickSuggestionLink = props =>
  <>
    {props.link.url.routed ? (
      <a className={props.className} href={props.link.url.path}>{props.link.title}</a>
    ) : (
      <a className={props.className} target="_blank" rel="noopener noreferrer" href={props.link.url.path}>{props.link.title}</a>
    )}
  </>;

ComponentClickSuggestionLink.propTypes = {
  className: PropTypes.string,
  link: PropTypes.object.isRequired
};

export default ComponentClickSuggestionLink;
